module.exports = __webpack_public_path__ + "static/media/necklace-gray.61dd8cfc.svg";